'use strict';

import { Entity } from '../Entity';
import { User } from './User';

export class UserNotificationPreference extends Entity {
  protected id: number;
  protected user;
  protected event;
  protected method;
  protected data;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.event = data.event;
    this.method = data.method;
    this.data = data.data;

    if (data.user) {
      this.user = data.user;
    }
  }

  public getId() {
    return this.id;
  }

  public getEvent() {
    return this.event;
  }

  public setEvent(event) {
    this.event = event;
    return this;
  }

  public getMethod() {
    return this.method;
  }

  public setMethod(method) {
    this.method = method;
    return this;
  }

  public getData() {
    return this.data;
  }

  public setData(data) {
    this.data = data;
    return this;
  }
}
